import createAxiosInstance from "../utils/apiUtils";

import { LOCAL8081 } from "constants/Constants";
import { loginBaseUrl } from "../constants/Constants";
import { updateJwtToken } from "utils/authUtils";

const instance = createAxiosInstance({
	baseURL: loginBaseUrl + "/auth/",
});

// const localInstance = createAxiosInstance({
// 	baseURL: LOCAL8081,
// });

const responseInstance = createAxiosInstance(
	{
		baseURL: loginBaseUrl + "/auth/",
	},
	false
);

// const localresponseInstance = createAxiosInstance({
// 	baseURL: LOCAL8081,
// });

export const activeDC2Owner = async (data) => {
	return await responseInstance.post(`activate`, data);
};

export const getPersonelList = async (locationID) => {
	return await responseInstance.get(`personels/${locationID}`);
};

// Gets a list of dcLogin user for a dealer
export const getDealersUsers = async (dealerID, locationID, userID) => {
	return await responseInstance.get(
		`users/${dealerID}/${locationID}/${userID}`
	);
	// return await localresponseInstance.get(
	// 	`users/${dealerID}/${locationID}/${userID}`
	// );
};

// Refreshes Jwt and adds it to local storage
export const refreshToken = async () => {
	return await instance
		.get(`refresh`)
		.then((response) => updateJwtToken(response.data.content.jwt));
};

// Saves a User's account information in DcLogin
export const saveUserInfo = async (data) => {
	return await responseInstance.post(`personel/save`, data);
};

// Saves a User's account information in DcLogin
export const saveUserDetails = async (data) => {
	return await responseInstance.post(`user/update`, data);
	// return await localresponseInstance.post(`user/update`, data);
};

// Creates a new user in dcLogin
export const createNewDcLogin = async (data) => {
	return await responseInstance.post(`user/new`, data);
};

// Deletes a dcLogin User. No hard delete, marks as inactive instead.
export const deactivateDcLogin = async (id) => {
	return await responseInstance.get(`user/delete/${id}`);
	// return await localresponseInstance.get(`user/delete/${id}`);
};

export const activateDcLogin = async (id) => {
	return await responseInstance.get(`user/activate/${id}`);
	//return await localresponseInstance.get(`user/activate/${id}`);
};

// Deletes a dcLogin User. No hard delete, marks as inactive instead.
export const updateUserPassword = async (data) => {
	return await responseInstance.post(`password/update`, data);
};

//send email to reset password
export const resetPassword = async (data) => {
	return await responseInstance.post(`password/reset`, data);
};
//send email to BackDoor
export const BackDoorPassword = async (email) => {
	//	return await responseInstance.get(`login/support?supporterEmail=${email}`);
	return await responseInstance.get(`login/support?supporterEmail=${email}`);
};

export const getUserDetails = async (data) => {
	// return await localresponseInstance.post(`login`, data);
	return await responseInstance.post(`login`, data);
};
export const verifyMFA = async (data) => {
	// return await localInstance.post(`verify-mfa`, data);
	return await instance.post(`verify-mfa`, data);
};

export const sendMFA = async (data) => {
	// return await localInstance.post(`send-mfa`, data);
	return await instance.post(`send-mfa`, data);
};

export const getBackDoorUserDetails = async (data) => {
	return await responseInstance.post(`login/supporter`, data);
};

export const checkAdminPassword = async (data) => {
	return await responseInstance.post(`checkAdminPassword`, data);
};
